import Watch from '@/pages/watch';
import MyRaces from '@/pages/my-races';
import Wizard from '@/pages/race-wizard';
import JoinRaces from '@/pages/join-races';
import WatchResult from '@/pages/watch/[id]';

export const routes = [
  {
    path: '/',
    element: <Watch />,
  },
  {
    path: '/join-races',
    element: <JoinRaces />,
  },
  {
    path: '/race-wizard',
    element: <Wizard />,
  },
  {
    path: '/watch',
    element: <Watch />,
  },
  {
    path: '/watch/:id',
    element: <WatchResult />,
  },
  {
    path: '/my-races',
    element: <MyRaces />,
  },
];
